<template>
    <div>

        <div class="bg-white shadow-lines sm:shadow-dreamy">

            <a id="step-create-card" class="flex px-8 py-8 justify-between items-center" href="" @click.prevent="stepChange">
                <span class="w-8 mr-8">
                    <template v-if="complete">
                        <svg width="30" height="30" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="15" cy="15" r="15" fill="#08A818"/><path d="M24.338 5.192L9.953 19.577l-5.286-5.285a.656.656 0 00-.928 0l-1.547 1.546a.656.656 0 000 .929l7.297 7.296a.656.656 0 00.928 0L26.813 7.667a.656.656 0 000-.928l-1.547-1.547a.656.656 0 00-.928 0z" fill="#fff"/></svg>
                    </template>
                    <template v-else>
                        <svg width="30" height="30" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="15" cy="15" r="14.5" stroke="#4A96D2"/><path d="M16.713 8.16h-2.58l-1.5.66v2.62l1.3-.48V22h2.78V8.16z" fill="#4A96D2"/></svg>
                    </template>
                </span>
                <span class="w-full text-black text-xl font-bold font-platform tracking-wider">
                    <template v-if="product.type === 'memorial_card'">Designa ditt minnesblad</template>
                    <template v-else-if="product.type === 'honor_card'">Designa ditt gåvoblad</template>
                </span>
                <span v-if="! open">
                    <span href="#" class="text-sm text-gray-400 underline hover:text-black">
                        Ändra
                    </span>
                </span>
            </a>

            <!-- Expanded -->
            <ValidationObserver ref="form">
                <div class="pb-4 px-4 sm:pb-8 sm:px-8" v-if="open && ! loading">

                <!-- Image -->
                <div class="mb-8">

                    <div class="flex mb-2">
                        <div class="w-1/2 mr-1 relative">
                            <CardImage :image="images[0]" :selected="selectedTemplateImage === images[0]" @select="selectImage"></CardImage>
                        </div>
                        <div class="w-1/2 ml-1 ml-1 relative">
                            <CardImage :image="images[1]" :selected="selectedTemplateImage === images[1]" @select="selectImage"></CardImage>
                        </div>
                    </div>

                    <div class="flex mb-2">
                        <div class="w-1/2 mr-1 relative">
                            <CardImage :image="images[2]" :selected="selectedTemplateImage === images[2]" @select="selectImage"></CardImage>
                        </div>
                        <div class="w-1/2 ml-1 bg-blue-600 rounded flex items-center justify-center relative">
                            <input type="file" accept="image/*" class="absolute w-full h-full top-0 left-0 opacity-0 z-40" style="cursor: pointer" @change="uploadImage" />

                            <template v-if="form.image.custom_id">
                                <div class="absolute w-full h-full z-20">
                                    <div class="absolute w-full h-full flex items-center justify-center z-20">
                                        <div>
                                            <div class="text-center mb-1">
                                                <svg class="inline" width="31" height="31" viewBox="0 0 31 31" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M26.1381 5.4906L10.7254 20.9033L5.06218 15.2401C4.78761 14.9656 4.34241 14.9656 4.06778 15.2401L2.41052 16.8974C2.13595 17.172 2.13595 17.6172 2.41052 17.8918L10.2282 25.7094C10.5027 25.984 10.9479 25.984 11.2225 25.7094L28.7897 8.14226C29.0643 7.86768 29.0643 7.42249 28.7897 7.14786L27.1325 5.4906C26.8579 5.21603 26.4127 5.21603 26.1381 5.4906V5.4906Z" fill="#08A818"/>
                                                </svg>
                                            </div>
                                            <div>
                                                <span v-if="! imageIsUploading" class="text-base tracking-wider underline text-blue-600">Byt egen bild</span>
                                                <span v-else class="text-sm text-blue-600">Laddar upp...</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="absolute w-full h-full bg-white opacity-75 flex items-center justify-center z-10"></div>
                                </div>
                                <div class="w-full h-24 bg-cover bg-center rounded" :style="`background-image: url(${form.image.url})`"></div>
                            </template>
                            <template v-else>
                                <div>
                                    <div class="text-center mb-2">
                                        <svg class="inline" width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M0 1a1 1 0 011-1h22a1 1 0 011 1v22a1 1 0 01-1 1H1a1 1 0 01-1-1V1zm7.331 11.958a1 1 0 011.554 0l1.698 2.095 2.88-3.946a1 1 0 011.615 0L20.108 18H3.243l4.088-5.042z" fill="#fff"/></svg>
                                    </div>
                                    <div>
                                        <span v-if="! imageIsUploading" class="text-sm underline text-white">Ladda upp bild</span>
                                        <span v-else class="text-sm text-white">Laddar upp...</span>
                                    </div>
                                </div>
                            </template>
                        </div>
                    </div>

                </div>

                <!-- Fields -->
                <div class="text-lg text-blue-400 font-semibold mb-2">
                    <template v-if="product.type === 'memorial_card'">Till minne av</template>
                    <template v-else-if="product.type === 'honor_card'">Högtid (t.ex Johan 75 år)</template>
                </div>
                <CardInput class="mb-8" label="" v-model="form.subject" @change="change" rules="required" />

                <div class="text-lg text-blue-400 font-semibold mb-1">Personlig hälsning</div>
                <div class="text-sm text-gray-400 mb-4">Skriv en personlig hälsning eller välj en fras. Avsluta  sedan med era namn.</div>

                <div class="mb-4 relative">
                    <div class="bg-blue-200 border-t border-l border-r border-gray-300 text-blue-400 py-2 px-2 text-sm flex justify-between items-center" v-if="greetings.length > 1">
                        <button @click="previousGreeting">
                            <svg class="fill-current text-blue-400" width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M11.53 18.799a.75.75 0 01-1.06 0l-6.25-6.25a.75.75 0 010-1.06l6.25-6.25a.75.75 0 111.06 1.06l-4.97 4.97H19a.75.75 0 110 1.5H6.56l4.97 4.97a.75.75 0 010 1.06z" /></svg>
                        </button>
                        <div>
                            Förslag på hälsningsfraser {{ currentGreeting + 1 }}/{{ greetings.length }}
                        </div>
                        <button @click="nextGreeting">
                            <svg class="fill-current text-blue-400" width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M12.47 5.201a.75.75 0 011.06 0l6.25 6.25a.75.75 0 010 1.06l-6.25 6.25a.75.75 0 11-1.06-1.06l4.97-4.97H5a.75.75 0 110-1.5h12.44l-4.97-4.97a.75.75 0 010-1.06z" /></svg>
                        </button>
                    </div>
                    <CardTextarea
                        v-model="form.greeting"
                        @change="change"
                        rules="required"
                        :limited="greetingValidation && ! greetingValidation.passes"
                    ></CardTextarea>
                    <div v-if="greetingValidation && ! greetingValidation.passes"
                         class="absolute text-base text-red-400 bg-red-200 text-center border border-red-400 py-3 "
                         style="top: 0; right: 0px; left: 0; margin-left: auto; margin-right: auto"
                    >
                        Texten är för lång
                    </div>
                </div>

                <div class="lg:hidden text-center mb-10 mt-8">
                    <a
                        @click.prevent="showMobilePreview"
                        href=""
                        class="text-lg text-blue-400 font-semibold mb-2 underline"
                    >Förhandsvisa</a>
                </div>

                <template v-if="showMobilePreviewIsVisible">
                    <div class="absolute bg-blue-400 top-0 left-0 w-full z-40">
                        <div class="fixed h-full w-full top-0 left-0" style="overflow-y: scroll; background-color: rgba(0, 0, 0, .55)">
                            <div class="pb-4">
                                <div class="text-center pt-8 pb-6">
                                    <card-button @click="hideMobilePreview">Stäng förhandsvisning</card-button>
                                </div>

                                <card-preview
                                    class="mx-4"
                                    :form="form"
                                    :product="product"
                                ></card-preview>


                            </div>
                        </div>
                    </div>
                </template>

                <div class="text-center mt-8 mb-2">
                    <card-button @click="next" :loading="saving">Till belopp</card-button>
                </div>

            </div>
            </ValidationObserver>
        </div>

    </div>
</template>

<script>
    import Event from "../event"
    import CardImage from "./CardImage"
    import axios from 'axios'
    import helpers from '../helpers'
    import CardInput from "./CardInput";
    import CardTextarea from "./CardTextarea";
    import { ValidationObserver } from 'vee-validate'
    import CardButton from "./CardButton";
    import CardPreview from "./CardPreview";

    export default {
        name: "CreateCard",
        mixins: [helpers],
        components: {CardPreview, CardButton, CardTextarea, CardInput, CardImage,ValidationObserver},
        props: {
            open: {type: Boolean, default: false},
            loading: {type: Boolean, default: false},
            product: {type: Object},
            images: {},
            form: {type: Object},
            greetings: {type: Array},
            greetingValidation: {type: Object},
        },
        watch: {
            open: function(newValue) {
                this.saving = !newValue
            },
            'form.greeting': function (value) {
                this.greetings[this.currentGreeting] = value
            }
        },
        data() {
            return {
                complete: false,
                imageIsUploading: false,
                selectedTemplateImage: {},
                selectedCustomImage: {},
                currentGreeting: 0,
                saving: false,
                showMobilePreviewIsVisible: false,
            }
        },
        async created() {
            this.selectImage(this.images[0])
            this.form.greeting = this.greetings[0]
        },
        methods: {
            showMobilePreview() {
                this.showMobilePreviewIsVisible = true
                document.body.style.overflow = 'hidden';
            },
            hideMobilePreview() {
                this.showMobilePreviewIsVisible = false
                document.body.style.overflow = 'visible';
            },
            nextGreeting() {
                this.currentGreeting++

                if (this.currentGreeting >= this.greetings.length) {
                    this.currentGreeting = 0
                }

                this.form.greeting = this.greetings[this.currentGreeting]
            },
            previousGreeting() {
                this.currentGreeting--

                if (this.currentGreeting < 0) {
                    this.currentGreeting = this.greetings.length - 1
                }

                this.form.greeting = this.greetings[this.currentGreeting]
            },
            stepChange() {
                this.$emit('step', 'create-card')
            },
            selectImage(image) {
                this.selectedCustomImage = {}
                this.selectedTemplateImage = image
                this.imageChange()
            },
            change() {
                this.$emit('change', this.form)
            },
            uploadImage(e) {
                let image = e.target.files[0]

                if (! image) {
                    return
                }

                let formData = new FormData()
                formData.append('image', image)
                this.imageIsUploading = true

                axios.post(this.api(`${this.$route.params.accountId}/images/store`), formData, {
                    headers: { 'content-type': 'multipart/form-data' }
                }).then((response) => {
                    this.imageIsUploading = false
                    this.selectedTemplateImage = {}
                    this.selectedCustomImage = {
                        uuid: response.data.uuid,
                        url: response.data.url
                    }
                    this.imageChange()
                }).catch((error) => {
                    this.imageIsUploading = false

                    if (error.response.data.message && error.response.data.message !== '') {
                        alert(error.response.data.message)
                    } else {
                        alert('Det verkar tyvärr som bilden är för stor. Prova att ladda upp en mindre bild')
                    }
                })
            },
            imageChange() {
                this.form.image.template_id = Object.keys(this.selectedTemplateImage).length ? this.selectedTemplateImage.id : null
                this.form.image.custom_id = Object.keys(this.selectedCustomImage).length ? this.selectedCustomImage.uuid : null
                this.form.image.url = Object.keys(this.selectedTemplateImage).length ? this.selectedTemplateImage.url : this.selectedCustomImage.url

                this.$emit('change', this.form)
            },
            next() {
                if (this.greetingValidation && ! this.greetingValidation.passes) {
                    return false
                }

                this.$refs.form.validate().then(success => {
                    if (success) {
                        this.complete = true
                        this.$emit('change', this.form)
                        this.saving = true
                        this.$emit('completed', {
                            step: 'create-card',
                        })
                    }
                })
            }
        }
    }
</script>
